import React from 'react'
import {Stack, useDisclosure, Text, Box, BaseButton} from '../../../../vanilla'
import {Modal} from '../../../../components/modal'
import {CloseIcon} from '../../../../components/icons'
import {SlotContentItem} from '../../../../types/cms'
import {Markdown} from '../../../../components/cms/Markdown'

export interface PreBookFAQModalContent extends SlotContentItem {
  title?: string
  bodyText?: string
}

interface PreBookFAQModalProps extends ReturnType<typeof useDisclosure> {
  content: PreBookFAQModalContent
}

export const PreBookFAQModal = ({content, ...props}: PreBookFAQModalProps) => (
  <Modal size="full-lg" closeIcon={false} allowScroll={true} {...props}>
    <Stack width="full" padding="28px" spacing="0px">
      <Box
        display="flex"
        alignItems="flex-start"
        justifyContent="space-between"
        borderBottom="1px"
        borderColor="gray200"
        marginBottom="16px"
      >
        <Text variant="heading1" paddingBottom="16px" data-test-selector="pre-book-faq-modal-title">
          {content.title}
        </Text>
        <BaseButton
          variant="unstyled"
          paddingX="0px"
          height="auto"
          aria-label="Close pre-book FAQ modal"
          onClick={props.onClose}
          data-test-selector="pre-book-faq-modal-close-button"
        >
          <CloseIcon boxSize="24px" />
        </BaseButton>
      </Box>
      <Markdown
        markdown={(content?.bodyText || '') as string}
        componentProps={{
          p: {
            textAlign: 'left',
            variant: 'text3',
            lineHeight: 'short',
            dataTestSelector: 'pre-book-faq-modal-body-text',
          },
          a: {
            variant: 'text3',
            textDecoration: 'underline',
            lineHeight: 'short',
            dataTestSelector: 'pre-book-faq-modal-body-link',
          },
        }}
      />
    </Stack>
  </Modal>
)
